import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { ImportserialService } from "../../services/importserial.service";
import { AccountsTransactionType } from "src/app/finance/constants/constants";
@Component({
    selector: "app-bill-payment-view",
    templateUrl: "./bill-payment-view.component.html",
    styleUrls: ["./bill-payment-view.component.scss"],
})
export class BillPaymentViewComponent implements OnInit {
    @Input() billPayDetails;
    @Input() isView : boolean = true;
    @Output() updateJournalList =new EventEmitter<boolean>();
    @Output() close =new EventEmitter<boolean>();

    length: number =0;
    bankAccounts=[];
    financialAccounts=[];
    billTemplate;
    billDetailsData;
    ordersVendorPhoneNew;
    ordersVendorContactNew;
    ordersVendorAddr;
    ordersVendorCity;
    ordersVendorState;
    ordersVendorCountry;
    ordersVendorZipcode;

    glApiCall = false;
    transactionTypeIds = AccountsTransactionType;
    billPayId : number;

    constructor(public app: AppMainComponent, private datePipe: DatePipe, private purchaseService: PurchasesService,
        private importService: ImportserialService
    ) { }

    ngOnInit(): void {   
        this.importService.getDecimalValue().subscribe(value => {
            if(value){
              this.length = value;
            }
          })
        this.loadFinancialAccounts();
        this.loadBankAccounts();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.billPayDetails?.currentValue) {
            this.billPayId = this.billPayDetails.id;
            this.billPayDetails = changes.billPayDetails.currentValue;
            // console.log('this.billPayDetails -->>', this.billPayDetails);
            this.parsePaymentDetails();
        }
    }
    showEditbillPayment(){
        this.isView = false;
    }
    parsePaymentDetails() {
        this.billDetailsData = [];
        this.billPayDetails.billDate = this.app._showDateTimeWithZone(
            this.billPayDetails.billDate
        );
        if (this.billPayDetails?.vendor?.vendorContacts?.length > 0) {
            for (let contact of this.billPayDetails.vendor?.vendorContacts) {
                if (contact?.contact?.isPrimaryContact) {
                    this.ordersVendorPhoneNew =
                        contact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContactNew =
                        contact.contact?.firstName +
                        " " +
                        contact.contact?.lastName;
                }
            }
        }
        if (this.billPayDetails?.vendor?.vendorAddresses?.length > 0) {
            for (let add of this.billPayDetails.vendor?.vendorAddresses) {
                if (
                    add.address?.addressType?.name == "Billing" &&
                    add.address?.isDefault
                ) {
                    this.ordersVendorAddr =
                        add.address?.streetAddress1 == ""
                            ? add.address?.streetAddress2
                            : add.address?.streetAddress1;
                    this.ordersVendorCity = add.address?.city?.name;
                    this.ordersVendorState = add.address?.state?.name;
                    this.ordersVendorCountry = add.address?.country?.name;
                    this.ordersVendorZipcode = add.address?.zipCode;
                } else {
                    this.ordersVendorAddr =
                        this.billPayDetails.vendor?.vendorAddresses[0].address
                            ?.streetAddress1 == ""
                            ? this.billPayDetails.vendor?.vendorAddresses[0]
                                .address?.streetAddress2
                            : this.billPayDetails.vendor?.vendorAddresses[0]
                                .address?.streetAddress1;
                    this.ordersVendorCity =
                        this.billPayDetails.vendor?.vendorAddresses[0].address?.city?.name;
                    this.ordersVendorState =
                        this.billPayDetails.vendor?.vendorAddresses[0].address?.state?.name;
                    this.ordersVendorCountry =
                        this.billPayDetails.vendor?.vendorAddresses[0].address?.country?.name;
                    this.ordersVendorZipcode =
                        this.billPayDetails.vendor?.vendorAddresses[0].address?.zipCode;
                }
            }

            for (let data of this.billPayDetails.billPaymentDetails) {
                const detailEach = {
                    id: data.id,
                    rpoId: data.receivedPurchaseOrderId,
                    ponumber: data.purchaseOrderNo,
                    rponumber: data.receivedPurchaseOrderNo,
                    billNo: data.billNumber,
                    rpodate: this.datePipe.transform(
                        this.app._showDateTimeWithZone(data.rpoDate),
                        "MM/dd/yyyy"
                    ),
                    discountamount: data.discountAmount,
                    amount: data.rpoTotalAmount,
                    paidamount: data.paidAmount,
                    appliedCredit: data.appliedCredit,
                    dueamount: data.pendingAmount,
                    status: data.billStatus,
                };
                this.billDetailsData.push(detailEach);
            }
        }
    }

    loadBankAccounts() {
        this.purchaseService.getAllBankFinancialAccounts().subscribe((accounts) => {
          this.bankAccounts = accounts;
        })
      }
    
      loadFinancialAccounts() {
        this.purchaseService.getAllFinancialAccounts().subscribe((accounts) => {
          let data = []
          for (let c of accounts) {
            let ChildData = [];
            for (let s of c.childAccounts) {
              let subData = [];
              for (let subb of s.childAccounts) {
                let childSubbData = [];
    
                //if (subb.statusId == 1) {
                let eachSub = {
                  label: `${subb.displayNumber || ""} - ${subb.name}`,
                  selectable: true,
                  value: subb,
                  children: childSubbData,
                };
                subData.push(eachSub);
                //}
              }
              let eachSub = {
                label: `${s.displayNumber || ""} - ${s.name}`,
                value: s,
                selectable: true,
                children: subData
              }
              ChildData.push(eachSub)
            }
    
            let eachData = {
              label: `${c.displayNumber || ""} - ${c.name}`,
              value: c,
              selectable: false,
              children: ChildData
            }
            data.push(eachData)
          }
          this.financialAccounts = data;
        })
      }

      updateJournal(){
        this.updateJournalList.emit();
      }

      cancel(){
        this.close.emit();
      }

      onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
      }
  
}
